import React, { useState } from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import PlannerShiftHoursRow from './PlannerShiftHoursRow';
import PlannerShiftHoursRowNumber from './PlannerShiftHoursRowNumber';
import { ITripPlannerValues } from '../types/locationTypes';

interface PlannerShiftHoursProps {
    parentClasses: ClassNameMap,
    setValue: any,
    value: string,
    planner: ITripPlannerValues,
    planners: ITripPlannerValues[],
    setPlanners: any,
    labelText: string,
    description: string,
    readonly:boolean,
    index:any,
}

interface PlannerShiftHoursRowProps {
    mon: any,
    tue: any,
    wed: any,
    thu: any,
    fri: any,
    sat: any,
    sun: any,
}
interface PlannerShiftHoursRowNumberProps {
    mon: number | null,
    tue: number | null,
    wed: number | null,
    thu: number | null,
    fri: number | null,
    sat: number | null,
    sun: number | null,
}

const PlannerShiftHours: React.FC<PlannerShiftHoursProps> = ({
    parentClasses,
    setValue,
    value,
    planner,
    planners,
    setPlanners,
    labelText,
    description,
    readonly,
    index
}) => {
    const [shiftStartTime, setShiftStartTime] = React.useState<PlannerShiftHoursRowProps>();
    const [shiftEndTime, setShiftEndTime] = React.useState<PlannerShiftHoursRowProps>();
    const [breakDuration, setBreakDuration] = React.useState<PlannerShiftHoursRowNumberProps>();
    const [breakStartTime, setBreakStartTime] = React.useState<PlannerShiftHoursRowProps>();
    const [maxBreakDelay, setMaxBreakDelay] = React.useState<PlannerShiftHoursRowNumberProps>();
    const [update, setUpdate] = useState(false);

    React.useEffect(() => {
        configureData(planner);
    }, [planner]);

    const timeConvert =(mins:any)=>{  
        if (mins==null) return null;
        var _hours = Math.floor(mins / 60);  
        var _minutes = mins % 60;
        var _hoursStr = "00";
        var _minutesStr = "00";
        if (_hours<10) _hoursStr="0" + _hours; else _hoursStr=_hours.toString(); 
        if (_minutes<10) _minutesStr="0" + _minutes; else _minutesStr=_minutes.toString(); 
        return _hoursStr + ":" + _minutesStr;    
    }

    const configureData =(planner:ITripPlannerValues)=>{
        var _sftStart={} as PlannerShiftHoursRowProps;
        _sftStart.sun=planner.sunFromString!=null ? planner.sunFromString:timeConvert(planner.sunFrom);
        _sftStart.mon=planner.monFromString!=null ? planner.monFromString:timeConvert(planner.monFrom);
        _sftStart.tue=planner.tueFromString!=null ? planner.tueFromString:timeConvert(planner.tueFrom);
        _sftStart.wed=planner.wedFromString!=null ? planner.wedFromString:timeConvert(planner.wedFrom);
        _sftStart.thu=planner.thurFromString!=null ? planner.thurFromString:timeConvert(planner.thurFrom);
        _sftStart.fri=planner.friFromString!=null ? planner.friFromString:timeConvert(planner.friFrom);
        _sftStart.sat=planner.satFromString!=null ? planner.satFromString:timeConvert(planner.satFrom);
        setShiftStartTime(_sftStart);
        var _sftEnd={} as PlannerShiftHoursRowProps;
        _sftEnd.sun=planner.sunToString!=null ? planner.sunToString:timeConvert(planner.sunTo);
        _sftEnd.mon=planner.monToString!=null ? planner.monToString:timeConvert(planner.monTo);
        _sftEnd.tue=planner.tueToString!=null ? planner.tueToString : timeConvert(planner.tueTo);
        _sftEnd.wed=planner.wedToString!=null ? planner.wedToString:timeConvert(planner.wedTo);
        _sftEnd.thu=planner.thurToString!=null ? planner.thurToString:timeConvert(planner.thurTo);
        _sftEnd.fri=planner.friToString!=null ? planner.friToString:timeConvert(planner.friTo);
        _sftEnd.sat=planner.satToString!=null ? planner.satToString:timeConvert(planner.satTo);
        setShiftEndTime(_sftEnd);
        var _brkStart={} as PlannerShiftHoursRowProps;
        _brkStart.sun=planner.breakStartSunString!=null ? planner.breakStartSunString:timeConvert(planner.breakStartSun);
        _brkStart.mon=planner.breakStartMonString!=null ? planner.breakStartMonString:timeConvert(planner.breakStartMon);
        _brkStart.tue=planner.breakStartTueString!=null ? planner.breakStartTueString:timeConvert(planner.breakStartTue);
        _brkStart.wed=planner.breakStartWedString!=null ? planner.breakStartWedString:timeConvert(planner.breakStartWed);
        _brkStart.thu=planner.breakStartThuString!=null ? planner.breakStartThuString:timeConvert(planner.breakStartThu);
        _brkStart.fri=planner.breakStartFriString!=null ? planner.breakStartFriString:timeConvert(planner.breakStartFri);
        _brkStart.sat=planner.breakStartSatString!=null ? planner.breakStartSatString:timeConvert(planner.breakStartSat);
        setBreakStartTime(_brkStart);
        var _brkDuration={} as PlannerShiftHoursRowNumberProps;
        _brkDuration.sun=planner.breakDurationSun;
        _brkDuration.mon=planner.breakDurationMon;
        _brkDuration.tue=planner.breakDurationTue;
        _brkDuration.wed=planner.breakDurationWed;
        _brkDuration.thu=planner.breakDurationThu;
        _brkDuration.fri=planner.breakDurationFri;
        _brkDuration.sat=planner.breakDurationSat;
        setBreakDuration(_brkDuration);
        var _maxBrkDelay={} as PlannerShiftHoursRowNumberProps;
        _maxBrkDelay.sun=planner.maxBreakDelaySun;
        _maxBrkDelay.mon=planner.maxBreakDelayMon;
        _maxBrkDelay.tue=planner.maxBreakDelayTue;
        _maxBrkDelay.wed=planner.maxBreakDelayWed;
        _maxBrkDelay.thu=planner.maxBreakDelayThu;
        _maxBrkDelay.fri=planner.maxBreakDelayFri;
        _maxBrkDelay.sat=planner.maxBreakDelaySat;
        setMaxBreakDelay(_maxBrkDelay);
     }
    
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setValue(event.target.value);
    // };

    return (
        <div className={parentClasses.shiftHourBase}>
            <div className={parentClasses.shiftHour}>
                <Grid container className={'shiftHourGrid header'}>
                    <Grid item md={3} sm={3}>
                        <div className={"labelSubText"}>
                            {labelText}
                        </div>
                    </Grid>
                    <Grid item md={9} sm={9} style={{flexBasis:'74.2%' }}>
                        <Grid container className={"weekDayGrid"}>
                            <Grid item>
                                <div className={"dayTitle"}>M</div>
                            </Grid>
                            <Grid item>
                                <div className={"dayTitle"}>T</div>
                            </Grid>
                            <Grid item>
                                <div className={"dayTitle"}>W</div>
                            </Grid>
                            <Grid item>
                                <div className={"dayTitle"}>T</div>
                            </Grid>
                            <Grid item>
                                <div className={"dayTitle"}>F</div>
                            </Grid>
                            <Grid item>
                                <div className={"dayTitle"}>S</div>
                            </Grid>
                            <Grid item>
                                <div className={"dayTitle"}>S</div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <PlannerShiftHoursRow
                    parentClasses={parentClasses}
                    title={"Shift Start Time"}
                    values={shiftStartTime}
                    planner={planner}
                    setUpdate={setUpdate}
                    planners={planners}
                    setPlanners={setPlanners}
                    readonly={readonly}
                    order={(index*35)+1}
                />
                <PlannerShiftHoursRow
                    parentClasses={parentClasses}
                    title={"Shift End Time"}
                    values={shiftEndTime}
                    planner={planner}
                    setUpdate={setUpdate}
                    planners={planners}
                    setPlanners={setPlanners}
                    readonly={readonly}
                    order={(index*35)+2}
                />
                <PlannerShiftHoursRowNumber
                    parentClasses={parentClasses}
                    title={"Break Duration (Mins)"}
                    values={breakDuration}
                    planner={planner}
                    setUpdate={setUpdate}
                    planners={planners}
                    setPlanners={setPlanners}
                    readonly={readonly}
                    order={(index*35)+3}
                />
                <PlannerShiftHoursRow
                    parentClasses={parentClasses}
                    title={"Break Start Time"}
                    values={breakStartTime}
                    planner={planner}
                    setUpdate={setUpdate}
                    planners={planners}
                    setPlanners={setPlanners}
                    readonly={readonly}
                    order={(index*35)+4}
                />
                <PlannerShiftHoursRowNumber
                    parentClasses={parentClasses}
                    title={"Max Break Delay (Hrs)"}
                    values={maxBreakDelay}
                    planner={planner}
                    setUpdate={setUpdate}
                    planners={planners}
                    setPlanners={setPlanners}
                    readonly={readonly}
                    order={(index*35)+5}
                />
            </div>
        </div>
    );
}

export default PlannerShiftHours;